import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
import styles from './chatTabItem.css'

class ChatTabItem extends Component {
  render() {
    const { role, active, tabName } = this.props
    const isActiveClass = active === tabName ? styles.chatTabActive : styles.chatTab
    const isAdminClass = role === 2 ? isActiveClass + ' '+ styles.chatTabAdmin : isActiveClass
    return (
      <li onClick={this.props.onClickTabs.bind(this, this.props.tabName)} className={isAdminClass}>
        <span className={styles.chatTabTitle}>{this.props.children}</span>
      </li>

    )
  }
}

export default CSSModules(ChatTabItem, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/Chat/ChatTabItem.js